module.exports = __webpack_public_path__ + "img/WHATSAPP.2dc4ef07.svg";